/**
 * TRH-2010 Ulusal Mortalite Tablosu — bakiye ömür (yıl)
 * Kaynak: yaygın yayımlanan TRH-2010 özet tabloları (E/K).
 */

export const TRH_2010_BAKIYE = {
  // yaş: [erkek, kadın]
  0: [71.93, 78.02],
  1: [72.35, 77.66],
  2: [71.42, 76.68],
  3: [70.47, 75.70],
  4: [69.52, 74.72],
  5: [68.57, 73.73],
  6: [67.60, 72.74],
  7: [66.63, 71.75],
  8: [65.66, 70.76],
  9: [64.68, 69.76],
  10: [63.70, 68.77],
  11: [62.72, 67.78],
  12: [61.74, 66.78],
  13: [60.76, 65.79],
  14: [59.78, 64.79],
  15: [58.80, 63.80],
  16: [57.84, 62.81],
  17: [56.87, 61.82],
  18: [55.91, 60.83],
  19: [54.95, 59.84],
  20: [53.99, 58.85],
  21: [53.04, 57.86],
  22: [52.09, 56.88],
  23: [51.14, 55.89],
  24: [50.19, 54.90],
  25: [49.24, 53.92],
  26: [48.28, 52.93],
  27: [47.33, 51.95],
  28: [46.37, 50.97],
  29: [45.41, 49.98],
  30: [44.45, 49.00],
  31: [43.50, 48.02],
  32: [42.54, 47.04],
  33: [41.58, 46.06],
  34: [40.62, 45.08],
  35: [39.67, 44.10],
  36: [38.72, 43.12],
  37: [37.77, 42.15],
  38: [36.81, 41.17],
  39: [35.87, 40.20],
  40: [34.93, 39.23],
  41: [33.99, 38.26],
  42: [33.05, 37.30],
  43: [32.12, 36.34],
  44: [31.19, 35.38],
  45: [30.27, 34.43],
  46: [29.36, 33.48],
  47: [28.46, 32.54],
  48: [27.56, 31.60],
  49: [26.67, 30.67],
  50: [25.79, 29.74],
  51: [24.93, 28.82],
  52: [24.06, 27.90],
  53: [23.21, 26.98],
  54: [22.37, 26.08],
  55: [21.54, 25.18],
  56: [20.74, 24.29],
  57: [19.94, 23.40],
  58: [19.15, 22.52],
  59: [18.38, 21.65],
  60: [17.62, 20.79],
  61: [16.88, 19.94],
  62: [16.14, 19.09],
  63: [15.42, 18.26],
  64: [14.72, 17.43],
  65: [14.04, 16.63],
  66: [13.37, 15.85],
  67: [12.72, 15.08],
  68: [12.08, 14.32],
  69: [11.47, 13.58],
  70: [10.87, 12.87],
  71: [10.29, 12.18],
  72: [9.73, 11.51],
  73: [9.20, 10.85],
  74: [8.68, 10.22],
  75: [8.17, 9.62],
  76: [7.69, 9.05],
  77: [7.24, 8.51],
  78: [6.81, 8.00],
  79: [6.40, 7.50],
  80: [5.99, 7.01],
  81: [5.59, 6.55],
  82: [5.23, 6.12],
  83: [4.90, 5.71],
  84: [4.57, 5.32],
  85: [4.25, 4.93],
  86: [3.93, 4.54],
  87: [3.64, 4.20],
  88: [3.37, 3.88],
  89: [3.12, 3.59],
  90: [2.90, 3.29],
  91: [2.66, 2.97],
  92: [2.39, 2.64],
  93: [2.10, 2.32],
  94: [1.80, 1.99],
  95: [1.55, 1.67],
  96: [1.40, 1.36],
  97: [1.23, 1.05],
  98: [0.96, 0.75], // SBM TRH-2010 tablosu (2026-10-04'te eklendi)
  99: [0.50, 0.50],
};

/**
 * TRH-2010 bakiye ömür — bilirkişi uygulamalarında olduğu gibi
 * kesirli yaşta lineer interpolasyon (örn. 28,97 → 45,44).
 * @param {number} ageYears
 * @param {'E'|'K'|string} cinsiyet
 * @returns {number} bakiye ömür (yıl)
 */
export function getBakiyeOmur(ageYears, cinsiyet = 'E') {
  const isFemale = String(cinsiyet).toUpperCase() === 'K' || String(cinsiyet).toLowerCase() === 'kadin';
  const idx = isFemale ? 1 : 0;
  const age = Math.max(0, Math.min(99, Number(ageYears) || 0));
  const lo = Math.floor(age);
  const hi = Math.min(99, lo + 1);
  const frac = age - lo;
  const vLo = (TRH_2010_BAKIYE[lo] || TRH_2010_BAKIYE[99])[idx];
  if (frac < 1e-12 || lo === hi) return vLo;
  const vHi = (TRH_2010_BAKIYE[hi] || TRH_2010_BAKIYE[99])[idx];
  return vLo + (vHi - vLo) * frac;
}
